import {
  getPublicGalleryImages,
  getPublicStorefrontName,
  getBroadStorefrontLocation,
  getStorefrontSlug,
  getStorefrontTheme,
  getStorefrontAvatarFrame,
  getStorefrontDecorationLevel,
  isStorefrontEnabled,
  normalizeStorefrontSlug,
} from "./storefront";

export const PUBLIC_STOREFRONT_COLLECTION = "publicStorefronts";

const PUBLIC_STOREFRONT_FIELDS = [
  "slug",
  "ownerId",
  "storefrontEnabled",
  "isPublic",
  "status",
  "publicName",
  "farmName",
  "businessName",
  "displayName",
  "profilePicture",
  "about",
  "city",
  "county",
  "state",
  "workImages",
  "farmAnimal",
  "farmAnimalSelectionExplicit",
  "avatarProfileType",
  "storefrontTheme",
  "storefrontAvatarFrame",
  "storefrontDecorationLevel",
];

const trimText = (value, maxLength = 240) =>
  String(value || "").trim().slice(0, maxLength);

export const buildPublicStorefrontProjection = (profile = {}, ownerId = "") => {
  const slug = normalizeStorefrontSlug(getStorefrontSlug(profile));
  if (!slug || !ownerId) return null;

  const enabled = isStorefrontEnabled(profile);
  const location = getBroadStorefrontLocation(profile);
  const gallery = getPublicGalleryImages(profile, 12).map((image) => ({
    url: trimText(image.url, 1000),
    caption: trimText(image.caption, 180),
    featured: image.featured === true,
  }));

  return {
    slug,
    ownerId: String(ownerId),
    storefrontEnabled: enabled,
    isPublic: profile.isPublic !== false,
    status: enabled && profile.isPublic !== false ? "active" : "hidden",
    publicName: trimText(getPublicStorefrontName(profile), 120),
    farmName: trimText(profile.farmName, 120),
    businessName: trimText(profile.businessName, 120),
    displayName: trimText(profile.displayName || profile.name, 120),
    profilePicture: trimText(profile.profilePicture || profile.photoURL, 1000),
    about: trimText(profile.about || profile.bio || profile.intro, 1200),
    city: trimText(profile.city, 100),
    county: trimText(profile.county, 120),
    state: trimText(profile.state, 80),
    workImages: gallery.filter((image) => image.url),
    farmAnimal: trimText(profile.farmAnimal, 40),
    farmAnimalSelectionExplicit: profile.farmAnimalSelectionExplicit === true,
    avatarProfileType: trimText(profile.avatarProfileType, 40),
    storefrontTheme: getStorefrontTheme(profile),
    storefrontAvatarFrame: getStorefrontAvatarFrame(profile),
    storefrontDecorationLevel: getStorefrontDecorationLevel(profile),
  };
};

export { PUBLIC_STOREFRONT_FIELDS };
